// extracted by mini-css-extract-plugin
export default {"eventBadge":"DateCellItem_eventBadge__TBn0X","eventText":"DateCellItem_eventText__ykjB4"};